import * as types from "../types/single-template";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  retrieveTemplateDetails,
  updateSingleTemplate,
} from "../../networking/single-template/networking";

function* fetchSingleTemplateDetails(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveTemplateDetails, action.payload);
      if (response.error === null) {
        yield put({
          type: types.SET_SINGLE_TEMPLATE_DETAILS,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente mal.");
      }
    } else {
      throw new Error("Kunne ikke hente mal.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SINGLE_TEMPLATE_DETAILS, message: e.error });
  }
}

function* performUpdateSingleTemplate(action) {
  try {
    if (action.details) {
      var response = yield call(updateSingleTemplate, action.details);
      if (response.error === null && response.payload !== null) {
        yield put({
          type: types.GRANT_UPDATE_SINGLE_TEMPLATE,
          update: response.payload,
        });
      } else {
        throw new Error("Kunne ikke oppdatere kunde.");
      }
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_UPDATE_SINGLE_TEMPLATE, message: error });
  }
}

function* singleTemplateSaga() {
  yield all([
    takeEvery(
      types.REQUEST_SINGLE_TEMPLATE_DETAILS,
      fetchSingleTemplateDetails
    ),
    takeEvery(
      types.REQUEST_UPDATE_SINGLE_TEMPLATE,
      performUpdateSingleTemplate
    ),
  ]);
}

export default singleTemplateSaga;
